// Nama File: AgentHighChart3D.tsx

import React from "react";
import { Card } from "react-bootstrap";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Highcharts3d from 'highcharts/highcharts-3d';

// Inisialisasi modul 3D untuk Highcharts
Highcharts3d(Highcharts);

// Helper function untuk mengubah format mata uang ke angka
const parseRevenue = (revenue: string): number => {
    // Menghapus simbol mata uang, koma, dan mengonversinya ke float.
    return parseFloat(revenue.replace(/[^0-9.]+/g, "")) || 0;
};

// Mendefinisikan ulang tipe data agar komponen ini mandiri
interface ReportAgentDataV4 {
    agent_name: string;
    revenue: string;
    room_nights: number;
    color?: string;
}

interface AgentHighChart3DProps {
    title: string;
    data: ReportAgentDataV4[];
    dataKey: 'room_nights' | 'revenue';
    valueFormatter?: (value: number) => string;
}

const AgentHighChart3D: React.FC<AgentHighChart3DProps> = ({ title, data, dataKey, valueFormatter }) => {

    // Transformasi data ke format yang dibutuhkan Highcharts
    const chartData = data.map(item => ({
        name: item.agent_name,
        y: dataKey === 'revenue' ? parseRevenue(item.revenue) : item.room_nights,
        color: item.color || undefined
    }));

    // Konfigurasi Opsi Highcharts
    const options: Highcharts.Options = {
        chart: {
            type: 'pie',
            backgroundColor: 'transparent',
            options3d: {
                enabled: true,
                alpha: 45, // Sudut kemiringan
            }
        },
        title: {
            text: title,
            align: 'center',
            style: {
                fontSize: '16px',
                fontWeight: 'bold',
            }
        },
        tooltip: {
            // Tooltip tetap ada untuk detail saat hover
            formatter: function () {
                const point = this.point as any;
                const value = this.y || 0;
                const formattedValue = valueFormatter ? valueFormatter(value) : value.toLocaleString();
                return `<b>${point.name}</b>: ${formattedValue} (${this.percentage?.toFixed(2)}%)`;
            }
        },
        // Opsi plot diubah untuk menampilkan label, bukan legend
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                depth: 45,       // Ketebalan 3D disesuaikan seperti contoh
                innerSize: '60%',// Ukuran lubang doughnut disesuaikan
                dataLabels: {
                    // Label diaktifkan
                    enabled: true,
                    // Format label hanya menampilkan nama point
                    format: '<b>{point.name}</b>',
                },
                // showInLegend dinonaktifkan (atau dihapus) karena kita tidak pakai legend
                // showInLegend: false 
            }
        },
        // Konfigurasi legend dihapus sepenuhnya agar tidak tampil
        series: [{
            type: 'pie',
            name: title,
            data: chartData
        }],
        credits: {
            enabled: false
        }
    };

    return (
        <Card className="h-100 shadow">
            <Card.Body>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                    containerProps={{ style: { height: '350px', width: '100%' } }}
                />
            </Card.Body>
        </Card>
    );
};

export default AgentHighChart3D;